const Arrow = ({ direction }) => {
  if (direction === "right") {
    return (
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.699219 7.00003C0.699219 6.55821 1.05739 6.20003 1.49922 6.20003H13.4992C13.941 6.20003 14.2992 6.55821 14.2992 7.00003C14.2992 7.44186 13.941 7.80003 13.4992 7.80003H1.49922C1.05739 7.80003 0.699219 7.44186 0.699219 7.00003Z"
          fill="#5B5555"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.6002 1.10101C7.91262 0.788594 8.41915 0.788594 8.73157 1.10101L14.0649 6.43435C14.3773 6.74677 14.3773 7.2533 14.0649 7.56572L8.73157 12.8991C8.41915 13.2115 7.91262 13.2115 7.6002 12.8991C7.28778 12.5866 7.28778 12.0801 7.6002 11.7677L12.3678 7.00003L7.6002 2.23238C7.28778 1.91997 7.28778 1.41343 7.6002 1.10101Z"
          fill="#5B5555"
        />
      </svg>
    );
  } else if (direction === "left") {
    return (
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.699219 7.00003C0.699219 6.55821 1.05739 6.20003 1.49922 6.20003H13.4992C13.941 6.20003 14.2992 6.55821 14.2992 7.00003C14.2992 7.44186 13.941 7.80003 13.4992 7.80003H1.49922C1.05739 7.80003 0.699219 7.44186 0.699219 7.00003Z"
          fill="#5B5555"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.39824 1.10101C7.71066 1.41343 7.71066 1.91997 7.39824 2.23238L2.63059 7.00003L7.39824 11.7677C7.71066 12.0801 7.71066 12.5866 7.39824 12.8991C7.08582 13.2115 6.57929 13.2115 6.26687 12.8991L0.933533 7.56572C0.621114 7.2533 0.621114 6.74677 0.933533 6.43435L6.26687 1.10101C6.57929 0.788594 7.08582 0.788594 7.39824 1.10101Z"
          fill="#5B5555"
        />
      </svg>
    );
  } else {
    return null;
  }
};

export default Arrow;
